import Facebook from './Facebook'
import axios from 'axios'

export default class Preview extends Facebook {
  constructor (user, parameters = null) {
    super(user)
    this.user = user
    this.parameters = parameters
  }
  addImage () {
    const data = new FormData()
    data.append('image_file', this.parameters.file)
    data.append('access_token', this.user.token)
    return axios({
      method: 'POST',
      url: `${this.user.selectedAdAccount}/adimages`,
      data,
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
      .then(res => {
        return res.data.images[this.parameters.file.name]
      })
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
  getAdPreview () {
    let linkData
    let objectStorySpec
    if (this.parameters.video) {
      linkData = {
        call_to_action: {type: this.parameters.callToAction, value: {link: this.parameters.link}},
        message: this.parameters.message,
        video_id: this.parameters.video.id,
        image_url: this.parameters.video.picture
      }
      objectStorySpec = {
        video_data: linkData,
        page_id: this.user.selectedAccount
      }
    } else {
      linkData = {
        call_to_action: {type: this.parameters.callToAction, value: {link: this.parameters.link}},
        description: this.parameters.description,
        link: this.parameters.link,
        message: this.parameters.message,
        name: this.parameters.name,
        caption: this.parameters.caption
      }
      if (this.parameters.hash) linkData.image_hash = this.parameters.hash
      else linkData.picture = this.parameters.image_url
      objectStorySpec = {
        link_data: linkData,
        page_id: this.user.selectedAccount
      }
    }
    return axios({
      method: 'GET',
      url: `generatepreviews`,
      params: {
        access_token: this.user.token,
        creative: {
          body: this.parameters.description,
          object_story_spec: objectStorySpec,
          authorization_category: this.parameters.political
        },
        ad_format: 'DESKTOP_FEED_STANDARD'
      }
    })
      .then(res => {
        return res.data.data[0].body
      })
      .catch(err => {
        throw new Error(JSON.stringify(err))
      })
  }
}
